import {UserService} from './userService.js';
import {ApplicationService} from './applicationService.js';
import {SecurityService} from './securityService.js';
import {CompanyService} from './companyService.js';
import {LookupService} from './lookupService.js';
import {TrackingService} from './trackingService.js';
import {BrandingService} from './brandingService.js';
import {NodeService} from './nodeService.js';
import {JobService} from './jobService.js';
import {PluginService} from './pluginService.js';
import {NotificationService} from './notificationService.js';
import {FeedbackService} from './feedbackService.js';
import {ErrorTicketService} from './errorTicketService.js';
import {UserMessageService} from './userMessageService.js';
import {EmailHistoryService} from './emailHistoryService.js';
import {AlertService} from './alertService.js';
import {HelpService} from './helpService.js';
import {MediaService} from './mediaService.js';
import {TestCaseService} from './testCaseService.js';
import {FileService} from './fileService.js';
import {ReportService} from './reportService.js';
import {BackgroundOutputService} from './backgroundOutputService.js';
import {FeatureSwitchService} from './featureswitchService.js';
import {ApplicationModuleService} from './applicationModuleService.js';
import {DashboardService} from './dashboardService.js';
import {CompanyTypeConfigService} from './companyTypeConfigService.js';
import {AccountManagementService} from './accountManagementService.js';
import {APIService} from './apiServices.js';
import {ArchiveService} from './archiveService.js';
import {MessageTemplateService} from './messageTemplateService.js';
import {SystemUpdateService} from './systemUpdateService.js';
import {AppScriptService} from './appScriptService.js';
import {WorkspaceService} from './workspaceService.js';
import {GridColumnLayoutService} from './gridColumnLayoutService.js';

export var Service = {
	userService: null,	
	applicationService: null,
	brandingService: null,
	securityService: null,
	companyService: null,
	lookupService: null,
	trackingService: null,
	nodeService: null,
	jobService: null,
	pluginService: null,
	notificationService: null,
	feedbackService: null,
	errorTicketService: null,
	userMessageService: null,
	alertService: null,
	helpService: null,
	mediaService: null,
	testCaseService: null,
	fileService: null,
	reportService: null,
	backgroundOutputService: null,
	featureswitchService: null,
	applicationModuleService: null,
	dashboardService: null,
	companyTypeConfigService: null,
	accountManagementService: null,
	apiService: null,
	archiveService: null,
	messageTemplateService: null,
	systemUpdateService: null,
	appScriptService: null,
	workspaceService: null,
	gridColumnLayoutService: null,
		
	getUserService: function(){
		if (!this.userService) {
			this.userService = new UserService();
		}
		return this.userService;
	},
	
	getApplicationService: function(){
		if (!this.applicationService) {
			this.applicationService = new ApplicationService();
		}
		return this.applicationService;
	},	
	
	getSecurityService: function(){
		if (!this.securityService) {
			this.securityService = new SecurityService();
		}
		return this.securityService;
	},
	
	getCompanyService: function(){
		if (!this.companyService) {
			this.companyService = new CompanyService();
		}
		return this.companyService;
	},
	
	getLookupService: function(){
		if (!this.lookupService) {
			this.lookupService = new LookupService();
		}
		return this.lookupService;
	},
	
	getTrackingService: function(){
		if (!this.trackingService) {
			this.trackingService = new TrackingService();
		}
		return this.trackingService;
	},
	
	getBrandingService: function(){
		if (!this.brandingService) {
			this.brandingService = new BrandingService();
		}
		return this.brandingService;
	},
	
	getNodeService: function(){
		if (!this.nodeService) {
			this.nodeService = new NodeService();
		}
		return this.nodeService;
	},
	
	getJobService: function(){
		if (!this.jobService) {
			this.jobService = new JobService();
		}
		return this.jobService;
	},	
	
	getPluginService: function(){
		if (!this.pluginService) {
			this.pluginService = new PluginService();
		}
		return this.pluginService;
	},
	
	getNotificationService: function(){
		if (!this.notificationService) {
			this.notificationService = new NotificationService();
		}
		return this.notificationService;
	},	
	
	getFeedbackService: function(){
		if (!this.feedbackService) {
			this.feedbackService = new FeedbackService();
		}
		return this.feedbackService;
	},
	
	getErrorTicketService: function(){
		if (!this.errorTicketService) {
			this.errorTicketService = new ErrorTicketService();
		}
		return this.errorTicketService;
	},
	
	getUserMessageService: function(){
		if (!this.userMessageService) {
			this.userMessageService = new UserMessageService();
		}
		return this.userMessageService;
	},

	getEmailHistoryService: function(){
		if (!this.emailHistoryService) {
			this.emailHistoryService = new EmailHistoryService();
		}
		return this.emailHistoryService;
	},
	
	getAlertService: function(){
		if (!this.alertService) {
			this.alertService = new AlertService();
		}
		return this.alertService;
	},	
	
	getHelpService: function(){
		if (!this.helpService) {
			this.helpService = new HelpService();
		}
		return this.helpService;
	},
	
	getMediaService: function(){
		if (!this.mediaService) {
			this.mediaService = new MediaService();
		}
		return this.mediaService;
	},	
	
	getTestCaseService: function(){
		if (!this.testCaseService) {
			this.testCaseService = new TestCaseService();
		}
		return this.testCaseService;
	},
	
	getFileService: function(){
		if (!this.fileService) {
			this.fileService = new FileService();
		}
		return this.fileService;
	},	
	
	getReportService: function(){
		if (!this.reportService) {
			this.reportService = new ReportService();
		}
		return this.reportService;
	},	
	
	getBackgroundOutputService: function(){
		if (!this.backgroundOutputService) {
			this.backgroundOutputService = new BackgroundOutputService();
		}
		return this.backgroundOutputService;
	},
	
	getFeatureSwitchService: function(){
		if (!this.featureswitchService) {
			this.featureswitchService = new FeatureSwitchService();
		}
		return this.featureswitchService;
	},

	getApplicationModuleService: function(){
		if (!this.applicationModuleService) {
			this.applicationModuleService = new ApplicationModuleService();
		}
		return this.applicationModuleService;
	},
	
	getDashboardService: function(){
		if (!this.dashboardService) {
			this.dashboardService = new DashboardService();
		}
		return this.dashboardService;
	},
	
	getCompanyTypeConfigService: function(){
		if (!this.companyTypeConfigService) {
			this.companyTypeConfigService = new CompanyTypeConfigService();
		}
		return this.companyTypeConfigService;
	},
	
	getAccountManagementService: function(){
		if (!this.accountManagementService) {
			this.accountManagementService = new AccountManagementService();
		}
		return this.accountManagementService;
	},
	
	getApiService: function(){
		if (!this.apiService) {
			this.apiService = new APIService();
		}
		return this.apiService;
	},
		
	getArchiveService: function(){
		if (!this.archiveService) {
			this.archiveService = new ArchiveService();
		}
		return this.archiveService;
	},
	
	getMessageTemplateService: function(){
		if (!this.messageTemplateService) {
			this.messageTemplateService = new MessageTemplateService();
		}
		return this.messageTemplateService;
	},
	
	getSystemUpdateService: function(){
		if (!this.systemUpdateService) {
			this.systemUpdateService = new SystemUpdateService();
		}
		return this.systemUpdateService;
	},
	
	getAppScriptService: function(){
		if (!this.appScriptService) {
			this.appScriptService = new AppScriptService();
		}
		return this.appScriptService;
	},

	getWorkspaceService: function(){
		if (!this.workspaceService) {
			this.workspaceService = new WorkspaceService();
		}
		return this.workspaceService;
	},

	getGridColumnLayoutService: function(){
		if (!this.gridColumnLayoutService) {
			this.gridColumnLayoutService = new GridColumnLayoutService();
		}
		return this.gridColumnLayoutService;
	}
		
};

